<template>
  <el-dialog
      :title="BinaBilgi.Adi+' Online İşlemler Yetki Ayarı'"
      :visible="Modal"
      center
      width="50%">
    <a @click="$emit('Modal',false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-alert
        v-if="!BinaBilgi.Online"
        title="İşlem yapılamaz"
        type="error"
        :closable="false"
        description="Hesaplar Online Görüntülemez olarak ayarlandığı için işlem yapılamaz. Bina Düzenle butonundan Hesaplar Online Görülür butonunu açarak yetkilendirmeyi düzenleyebilirsiniz.">
    </el-alert>
    <el-form v-if="BinaBilgi.Online" :model="Form" @submit.prevent.native="Submit" ref="Form">
      <el-row :gutter="24">
        <el-col :span="4" class="text-center">
          <el-form-item label="Kasa Ekstresi" prop="ekstre">
            <el-switch v-model="Form.ekstre"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="text-center">
          <el-form-item label="Kasa Gelir Raporu" prop="gelir">
            <el-switch v-model="Form.gelir"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="text-center">
          <el-form-item label="Kasa Gider Raporu" prop="gider">
            <el-switch v-model="Form.gider"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4" class="text-center">
          <el-form-item label="Alacak Raporu" prop="alacak">
            <el-switch v-model="Form.alacak"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4" class="text-center">
          <el-form-item label="Borç Raporu" prop="borc">
            <el-switch v-model="Form.borc"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Android Uygulama Linki" prop="Android">
            <el-input
                placeholder="Android"
                size="small"
                v-model="Form.Android">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Ios Uygulama Linki" prop="Ios">
            <el-input
                size="small"
                placeholder="Ios"
                v-model="Form.Ios">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer text-center">
      <el-button type="primary" class="float-right" size="medium" @click="Submit()" icon="el-icon-check">
        Kaydet
      </el-button>
      <div class="clearfix"></div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['BinaBilgi', 'Modal'],
  data() {
    return {
      Form: {
        ekstre: true,
        gelir: true,
        gider: true,
        alacak: true,
        borc: true,
        Android: null,
        Ios: null,
      }
    }
  },
  methods: {
    Submit() {
      this.$store.dispatch("Post", {
        ...this.Form,
        path: 'yonetim/bina/oim/' + this.BinaBilgi.id
      }).then(response => {
        if (response.Durum == 'OK') {
          this.$message.success(response.Mesaj);
          this.$emit('Modal', true);
        } else {
          this.$message.error(response.Mesaj);
        }

      })
    }
  },
  created() {
    if (this.BinaBilgi.OimYetki) this.Form = this.BinaBilgi.OimYetki;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/OimYetkiModal.vue